<template>
    <div class="flex ai:center jc:space-between w:full">
        <span :class="{ 'cursor:pointer': !readonly }" @click="setValue(num)" :key="num" v-for="(num) in max">
            <img alt="" :src="`${prefix}image/star_${modelValue >= num ? 'on' : 'off'}.svg`" />
        </span>
    </div>
</template>

<script setup>
    const prefix = inject("prefix");

    const { readonly } = defineProps({
        max: { default: 5, type: Number },
        maxLabel: { type: String },
        minLabel: { type: String },
        modelValue: { default: 0, type: Number },
        readonly: { default: false, type: Boolean }
    });

    const emit = defineEmits(["update:modelValue"]);

    const setValue = (value) => {
        if (!readonly) {
            emit("update:modelValue", value);
        }
    };
</script>
